import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const BottomGamesSliderContainer = styled.div`
  margin-top: 32px;

   @media (${device.mobile}) {
        margin-top: 16px;
  }
`;
